import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { formDateFilter } from "@monorepo/utils/src/api/convertFiltersToApi";
import { convertAutocompleteItemToApi } from "@monorepo/utils/src/api/convertFiltersToApi";
import { fields } from "@monorepo/utils/src/variables/projectsData/receiptDocumentsBookReport/fields";

export const convertFiltersCustomToApi = (resultFilters: ITableFiltersObject & { fieldFilters: { date?: string } }): void => {
  formDateFilter(resultFilters, fields.FILTER_PERIOD);
  convertAutocompleteItemToApi(resultFilters, fields.FILTER_ARCHIVE, `fieldFilters.${fields.FILTER_ARCHIVE}.code`);
};
